<template>
  <div class="mobile-menu">
    <router-link :to="'/'"
      ><img class="mobile-menu__logo" src="../assets/img/logo.svg"
    /></router-link>

    <ul class="mobile-menu__menu">
      <li v-for="(menuItem, index) in menuItems" :key="index">
        <router-link
          :class="{ '--active': checkActive(menuItem.url) }"
          :to="'/' + menuItem.url"
          @click="hideMobileMenu()"
        >
          <svg
            v-show="checkActive(menuItem.url)"
            class="_border-l"
            width="16"
            height="65"
            viewBox="0 0 14 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.23022 1.66547C10.3469 0.596611 11.8331 0 13.3789 0H14V56H13.3789C11.8331 56 10.3469 55.4034 9.23022 54.3345L1.85128 47.2719C0.668764 46.1401 0 44.5743 0 42.9374V13.0626C0 11.4257 0.668764 9.8599 1.85128 8.72808L9.23022 1.66547Z"
              fill="#00188A"
            />
          </svg>

          {{ menuItem.title }}
          <svg
            v-show="checkActive(menuItem.url)"
            class="_border-r"
            width="16"
            height="65"
            viewBox="0 0 14 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.76978 54.3345C3.65305 55.4034 2.16688 56 0.621068 56H0L0 0H0.621069C2.16688 0 3.65305 0.596611 4.76978 1.66547L12.1487 8.72808C13.3312 9.85991 14 11.4257 14 13.0626L14 42.9374C14 44.5743 13.3312 46.1401 12.1487 47.2719L4.76978 54.3345Z"
              fill="#00188A"
            />
          </svg>
        </router-link>
      </li>
      <li><span class="--where" @click="showBuyOptions()">Где купить</span></li>
      <li>
        <a
          href="https://contactus.mdlzapps.com/mondelezinternationalcom/contact/ru-RU/"
          target="_blank"
          >Обратная связь</a
        >
      </li>
    </ul>

    <img
      class="mobile-menu__close"
      @click="hideMobileMenu()"
      src="../assets/img/burger-close.svg"
      alt=""
    />

    <img
      class="mobile-menu__kr"
      src="../assets/img/bright-taste/kr-1.png"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "MobileMenu",
  components: {},
  data() {
    return {
      menuItems: [
        { url: "", title: "Главная" },
        { url: "products", title: "Продукция" },
      ],
    }
  },
  methods: {
    showBuyOptions() {
      this.$emit("buy-options")
    },
    hideMobileMenu() {
      this.$emit("hide")
    },
    checkActive(url) {
      return (
        (url == "" && this.$route.path == "/") ||
        (url != "" && this.$route.path == "/" + url)
      )
    },
  },
}
</script>

<style lang="scss">
.mobile-menu {
  background: $color-yellow;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  &__logo {
    width: 64px;
    position: absolute;
    left: 17px;
    top: 6px;
  }
  &__kr {
    width: 204px;
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-55%) rotate(-5deg);
  }
  &__close {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  &__menu {
    display: grid;
    gap: 30px;
    font-family: $font-peach;
    font-size: 4rem;
    text-transform: uppercase;
    color: $color-blue;
    text-align: center;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -70%);
    list-style: none;
    a {
      color: $color-blue;
      line-height: 1;
      display: inline-flex;
      align-items: center;
      height: 65px;
      position: relative;
      padding: 0 8px;
    }
    .--active {
      background-color: $color-blue;
      color: white;
      transform: rotate(-7deg);
      transition: color 0.1s ease-in;
      ._border-l,
      ._border-r {
        position: absolute;
        top: 0;
        path {
          fill: $color-blue;
        }
      }
      ._border-l {
        left: -15px;
      }
      ._border-r {
        right: -15px;
      }
    }
  }
}
</style>
